import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "gridContainer": "campaign-page-92461c5b-gridContainer-WXUgJq",
  "default6": "campaign-page-92461c5b-default6-WXUgJq",
  "tiny11": "campaign-page-92461c5b-tiny11-WXUgJq",
  "confinedOffset4": "campaign-page-92461c5b-confinedOffset4-WXUgJq",
  "confined5": "campaign-page-92461c5b-confined5-WXUgJq",
  "xwide4": "campaign-page-92461c5b-xwide4-WXUgJq",
  "xwideOffset3": "campaign-page-92461c5b-xwideOffset3-WXUgJq",
  "confinedOffset1": "campaign-page-92461c5b-confinedOffset1-WXUgJq",
  "wide1": "campaign-page-92461c5b-wide1-WXUgJq",
  "xwide5": "campaign-page-92461c5b-xwide5-WXUgJq",
  "confinedOffset11": "campaign-page-92461c5b-confinedOffset11-WXUgJq",
  "xwide7": "campaign-page-92461c5b-xwide7-WXUgJq",
  "confinedOffset6": "campaign-page-92461c5b-confinedOffset6-WXUgJq",
  "xwideOffset11": "campaign-page-92461c5b-xwideOffset11-WXUgJq",
  "xwide10": "campaign-page-92461c5b-xwide10-WXUgJq",
  "wideGridContainer": "campaign-page-92461c5b-wideGridContainer-WXUgJq",
  "default4": "campaign-page-92461c5b-default4-WXUgJq",
  "xwideOffset8": "campaign-page-92461c5b-xwideOffset8-WXUgJq",
  "col": "campaign-page-92461c5b-col-WXUgJq",
  "default9": "campaign-page-92461c5b-default9-WXUgJq",
  "wideOffset11": "campaign-page-92461c5b-wideOffset11-WXUgJq",
  "default0": "campaign-page-92461c5b-default0-WXUgJq",
  "tinyOffset10": "campaign-page-92461c5b-tinyOffset10-WXUgJq",
  "xwideOffset4": "campaign-page-92461c5b-xwideOffset4-WXUgJq",
  "tinyOffset11": "campaign-page-92461c5b-tinyOffset11-WXUgJq",
  "default8": "campaign-page-92461c5b-default8-WXUgJq",
  "confined2": "campaign-page-92461c5b-confined2-WXUgJq",
  "confined8": "campaign-page-92461c5b-confined8-WXUgJq",
  "xwide11": "campaign-page-92461c5b-xwide11-WXUgJq",
  "confined4": "campaign-page-92461c5b-confined4-WXUgJq",
  "wide8": "campaign-page-92461c5b-wide8-WXUgJq",
  "confinedOffset2": "campaign-page-92461c5b-confinedOffset2-WXUgJq",
  "defaultOffset7": "campaign-page-92461c5b-defaultOffset7-WXUgJq",
  "xwide3": "campaign-page-92461c5b-xwide3-WXUgJq",
  "default10": "campaign-page-92461c5b-default10-WXUgJq",
  "confined10": "campaign-page-92461c5b-confined10-WXUgJq",
  "xwideOffset2": "campaign-page-92461c5b-xwideOffset2-WXUgJq",
  "confined12": "campaign-page-92461c5b-confined12-WXUgJq",
  "default7": "campaign-page-92461c5b-default7-WXUgJq",
  "xwide2": "campaign-page-92461c5b-xwide2-WXUgJq",
  "wideOffset7": "campaign-page-92461c5b-wideOffset7-WXUgJq",
  "wide2": "campaign-page-92461c5b-wide2-WXUgJq",
  "defaultOffset1": "campaign-page-92461c5b-defaultOffset1-WXUgJq",
  "confinedOffset5": "campaign-page-92461c5b-confinedOffset5-WXUgJq",
  "tinyOffset3": "campaign-page-92461c5b-tinyOffset3-WXUgJq",
  "confinedOffset7": "campaign-page-92461c5b-confinedOffset7-WXUgJq",
  "tiny6": "campaign-page-92461c5b-tiny6-WXUgJq",
  "tinyOffset0": "campaign-page-92461c5b-tinyOffset0-WXUgJq",
  "wide6": "campaign-page-92461c5b-wide6-WXUgJq",
  "wideOffset8": "campaign-page-92461c5b-wideOffset8-WXUgJq",
  "wide4": "campaign-page-92461c5b-wide4-WXUgJq",
  "default3": "campaign-page-92461c5b-default3-WXUgJq",
  "wideOffset3": "campaign-page-92461c5b-wideOffset3-WXUgJq",
  "wideOffset2": "campaign-page-92461c5b-wideOffset2-WXUgJq",
  "xwide9": "campaign-page-92461c5b-xwide9-WXUgJq",
  "defaultOffset3": "campaign-page-92461c5b-defaultOffset3-WXUgJq",
  "wideOffset10": "campaign-page-92461c5b-wideOffset10-WXUgJq",
  "confined0": "campaign-page-92461c5b-confined0-WXUgJq",
  "tinyOffset4": "campaign-page-92461c5b-tinyOffset4-WXUgJq",
  "wide0": "campaign-page-92461c5b-wide0-WXUgJq",
  "xwideOffset1": "campaign-page-92461c5b-xwideOffset1-WXUgJq",
  "tiny2": "campaign-page-92461c5b-tiny2-WXUgJq",
  "defaultOffset11": "campaign-page-92461c5b-defaultOffset11-WXUgJq",
  "wide7": "campaign-page-92461c5b-wide7-WXUgJq",
  "defaultOffset8": "campaign-page-92461c5b-defaultOffset8-WXUgJq",
  "tiny3": "campaign-page-92461c5b-tiny3-WXUgJq",
  "default5": "campaign-page-92461c5b-default5-WXUgJq",
  "xwideOffset10": "campaign-page-92461c5b-xwideOffset10-WXUgJq",
  "tinyOffset5": "campaign-page-92461c5b-tinyOffset5-WXUgJq",
  "xwide6": "campaign-page-92461c5b-xwide6-WXUgJq",
  "defaultOffset6": "campaign-page-92461c5b-defaultOffset6-WXUgJq",
  "confined11": "campaign-page-92461c5b-confined11-WXUgJq",
  "tinyOffset8": "campaign-page-92461c5b-tinyOffset8-WXUgJq",
  "confinedOffset10": "campaign-page-92461c5b-confinedOffset10-WXUgJq",
  "default12": "campaign-page-92461c5b-default12-WXUgJq",
  "xwideOffset0": "campaign-page-92461c5b-xwideOffset0-WXUgJq",
  "tinyOffset2": "campaign-page-92461c5b-tinyOffset2-WXUgJq",
  "xwide8": "campaign-page-92461c5b-xwide8-WXUgJq",
  "defaultOffset5": "campaign-page-92461c5b-defaultOffset5-WXUgJq",
  "tiny7": "campaign-page-92461c5b-tiny7-WXUgJq",
  "confinedOffset8": "campaign-page-92461c5b-confinedOffset8-WXUgJq",
  "standardGridContainer": "campaign-page-92461c5b-standardGridContainer-WXUgJq",
  "confined1": "campaign-page-92461c5b-confined1-WXUgJq",
  "wideOffset9": "campaign-page-92461c5b-wideOffset9-WXUgJq",
  "row": "campaign-page-92461c5b-row-WXUgJq",
  "defaultOffset4": "campaign-page-92461c5b-defaultOffset4-WXUgJq",
  "wideOffset4": "campaign-page-92461c5b-wideOffset4-WXUgJq",
  "xwide12": "campaign-page-92461c5b-xwide12-WXUgJq",
  "xwideOffset9": "campaign-page-92461c5b-xwideOffset9-WXUgJq",
  "tiny5": "campaign-page-92461c5b-tiny5-WXUgJq",
  "confinedOffset9": "campaign-page-92461c5b-confinedOffset9-WXUgJq",
  "wide11": "campaign-page-92461c5b-wide11-WXUgJq",
  "tinyOffset6": "campaign-page-92461c5b-tinyOffset6-WXUgJq",
  "confined6": "campaign-page-92461c5b-confined6-WXUgJq",
  "wide12": "campaign-page-92461c5b-wide12-WXUgJq",
  "confined3": "campaign-page-92461c5b-confined3-WXUgJq",
  "tiny8": "campaign-page-92461c5b-tiny8-WXUgJq",
  "defaultOffset10": "campaign-page-92461c5b-defaultOffset10-WXUgJq",
  "xwideOffset7": "campaign-page-92461c5b-xwideOffset7-WXUgJq",
  "confinedOffset0": "campaign-page-92461c5b-confinedOffset0-WXUgJq",
  "xwideOffset5": "campaign-page-92461c5b-xwideOffset5-WXUgJq",
  "xwide0": "campaign-page-92461c5b-xwide0-WXUgJq",
  "xwideOffset6": "campaign-page-92461c5b-xwideOffset6-WXUgJq",
  "grid": "campaign-page-92461c5b-grid-WXUgJq",
  "default1": "campaign-page-92461c5b-default1-WXUgJq",
  "wide9": "campaign-page-92461c5b-wide9-WXUgJq",
  "tiny9": "campaign-page-92461c5b-tiny9-WXUgJq",
  "defaultOffset2": "campaign-page-92461c5b-defaultOffset2-WXUgJq",
  "tinyOffset7": "campaign-page-92461c5b-tinyOffset7-WXUgJq",
  "wideOffset6": "campaign-page-92461c5b-wideOffset6-WXUgJq",
  "default11": "campaign-page-92461c5b-default11-WXUgJq",
  "wide5": "campaign-page-92461c5b-wide5-WXUgJq",
  "wide10": "campaign-page-92461c5b-wide10-WXUgJq",
  "tiny0": "campaign-page-92461c5b-tiny0-WXUgJq",
  "tiny10": "campaign-page-92461c5b-tiny10-WXUgJq",
  "tiny4": "campaign-page-92461c5b-tiny4-WXUgJq",
  "wide3": "campaign-page-92461c5b-wide3-WXUgJq",
  "tinyOffset1": "campaign-page-92461c5b-tinyOffset1-WXUgJq",
  "wideOffset5": "campaign-page-92461c5b-wideOffset5-WXUgJq",
  "confinedOffset3": "campaign-page-92461c5b-confinedOffset3-WXUgJq",
  "tinyOffset9": "campaign-page-92461c5b-tinyOffset9-WXUgJq",
  "confined9": "campaign-page-92461c5b-confined9-WXUgJq",
  "defaultOffset9": "campaign-page-92461c5b-defaultOffset9-WXUgJq",
  "tiny12": "campaign-page-92461c5b-tiny12-WXUgJq",
  "wideOffset0": "campaign-page-92461c5b-wideOffset0-WXUgJq",
  "wideOffset1": "campaign-page-92461c5b-wideOffset1-WXUgJq",
  "confined7": "campaign-page-92461c5b-confined7-WXUgJq",
  "armstrongGridContainer": "campaign-page-92461c5b-armstrongGridContainer-WXUgJq",
  "tiny1": "campaign-page-92461c5b-tiny1-WXUgJq",
  "xwide1": "campaign-page-92461c5b-xwide1-WXUgJq",
  "default2": "campaign-page-92461c5b-default2-WXUgJq"
};